function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   background-image: url(", ");\n   background-size: auto 44px;\n   background-position-y: 1rem;\n   background-position-x: center;\n   background-repeat: no-repeat;\n   min-height: ", ";\n   padding-top: ", ";\n   padding-bottom: 1.5rem;\n   display: flex;\n   align-items: center;\n\n   ", " {\n      padding-top: 0;\n      padding-bottom: 0;\n      background-position-y: center;\n      background-position-x: left;\n   }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import { createBreakpoint } from '../../util/createBreakpoint';
import somosLogo from './somosLogo.png';
var SiteFooterLogoWrapper = styled.div(_templateObject(), somosLogo, function (_ref) {
  var theme = _ref.theme;
  return theme.sizes.siteHeaderHeight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.sizes.siteHeaderHeight;
}, function (_ref3) {
  var theme = _ref3.theme;
  return createBreakpoint('above', 'md', theme);
});
export { SiteFooterLogoWrapper };